module.exports = [{"ID":1,"label":"Termites"},{"ID":2,"label":"Capricornes"},{"ID":3,"label":"Vrillettes"}]


//////////////////
// WEBPACK FOOTER
// ./src/services/devis/categories.json
// module id = 438
// module chunks = 0